import React from "react";
import "./FooterRegulation.scss";

type LogoDetails = {
    file: {
        url: string;
    };
    title?: string;
};

interface FooterRegulationProps {
    logoServiceEmpleo: LogoDetails;
    logoComfama: LogoDetails;
    logoAsojacas: LogoDetails;
    logoRedPactoGlobal: LogoDetails;
    logoSupersubsitio: LogoDetails;
    description: React.ReactNode;
}

const mainClassName = "a-footer-regulation";

function FooterRegulation({
    logoServiceEmpleo,
    logoComfama,
    logoAsojacas,
    logoRedPactoGlobal,
    logoSupersubsitio,
    description,
}: FooterRegulationProps) {
    return (
        <section className={`o_footer__logos ${mainClassName}`}>
            {/* Logo servicio  de empleo y comfama */}
            <div className={`${mainClassName}__logosempleo`}>
                <div>
                    <img
                        className={`logoempleo`}
                        src={logoServiceEmpleo.file.url}
                        alt={
                            logoServiceEmpleo.title || "Logo Servicio de empleo"
                        }
                    />
                </div>
                <div>
                    <img
                        className={`logocomfama`}
                        src={logoComfama.file.url}
                        alt={logoComfama.title || "Logo Comfama"}
                    />
                </div>
            </div>

            {/* resolucion */}
            <div className={`${mainClassName}__resolucion`}>
                <p>{description}</p>

                <span>Comfama es un sitio seguro.</span>
            </div>

            {/* Asocajas */}
            <div className={`${mainClassName}__asocajas`}>
                <div>
                    <img
                        className={`logoasojacas`}
                        src={logoAsojacas.file.url}
                        alt={logoAsojacas.title || "Logo Asojacas"}
                    />
                </div>

                <div>
                    <img
                        className={`logoredpactoglobal`}
                        src={logoRedPactoGlobal.file.url}
                        alt={
                            logoRedPactoGlobal.title || "Logo Red Pacto Global"
                        }
                    />
                </div>
            </div>

            {/* supersubsitio */}
            <div>
                <a
                    rel="noopener noreferrer"
                    href="https://www.ssf.gov.co/"
                    target="_blank"
                >
                    <img
                        className={`logosupersubsitio`}
                        src={logoSupersubsitio.file.url}
                        alt={logoSupersubsitio.title || "Logo Supersubsitio"}
                    />
                </a>
            </div>

            {/* warning */}
            <div className={`${mainClassName}__warning`}>
                <p>
                    Este sitio funciona mejor con Internet Explorer 10 en
                    adelante con vista de compatibilidad activada, <br /> Google
                    Chrome y Firefox y en resolución 1024 x 768 px.
                </p>
            </div>

            {/* normativa */}
            <div className={`${mainClassName}__normativa`}>
                <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://www.comfama.com/servicio-de-empleo/Normatividadoperativa/"
                >
                    Normatividad Operativa
                </a>
            </div>
        </section>
    );
}

export default FooterRegulation;
